<template>
  <div class="action-toolbar" v-if="game.state.gameplay.actionModes.length > 0 && game.state.activePlayMode !== 'replay'">
    <ion-button
      v-for="mode in game.state.gameplay.actionModes"
      :key="mode"
      :disabled="!game.state.gameplay.actionModeStates[mode]"
      @click="setActionMode(mode)"
      :color="game.state.gameplay.currentActionMode === mode ? 'primary' : 'secondary'"
    >
      <Icon :icon="getModeIcon(mode)" />
    </ion-button>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { IonButton } from '@ionic/vue';
import { Icon } from '@iconify/vue';
import { GameEvents } from '../lib/GameEvents';

const game = inject('game');

const modeIcons = {
  STANDARD: 'mdi:sword-cross',
  RANGED_ATTACK: 'mdi:bow-arrow',
  VISUALIZE: 'mdi:eye-outline',
};

const getModeIcon = (mode) => modeIcons[mode] || mode;
const setActionMode = (mode) => game.dispatch(GameEvents.SET_ACTION_MODE, mode);
</script>

<style scoped>
.action-toolbar {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  background-color: var(--hw-bg-overlay);
  border: 1px solid var(--hw-border);
  padding: 10px;
  border-radius: var(--hw-radius);
  z-index: 1000;
}

.action-toolbar ion-button {
  font-size: 1.5em;
  min-width: 50px;
  min-height: 50px;
}
</style>
